'use strict';

/**
 * All JS for the ProfileWysiwygContents controller
 */
waApp.controllers.ProfileWysiwygContents = {
	edit: function() {
		waUtils.inputLanguageToggle();
	}
};
